import React from 'react';
import Page from 'src/components/Page';
import Table from 'src/components/Table';

function ThreeDSecure(){
 return <Page header="Overview">

    <h2>3D Secure</h2>
    <p>    
        3D Secure 2.0 helps prevent fraud for eCommerce and online payments. Customers are quickly verified so they get a smoother, more secure payment experience. 
        You get increased protection against disputes and chargebacks relating to fraud. To understand more about 3D Secure 2.0 and how it works, 
        please check it <a href="https://www.commbank.com.au/business/merchant-services/emv-3d-secure.html">here</a>.
    </p>

    <h3>How to enable 3D Secure on the BPOINT API and Hosted Payment Page (HPP)</h3>
    <p>
        To enable 3D Secure 2.0 on your BPOINT Hosted Payment Page, please contact your Relationship Manager or our Merchant Support Helpdesk on 1800 230 177 
        (option 1, 3, 1) Monday to Friday 9am to 5pm (AEST).
    </p>
    
    <p>You may be asked to provide your Merchant ID, Merchant technical contact SPOC email ID, API version, and API method being used. </p> 
    <p>3D Secure is available for the following payment methods:</p>
    <Table
        headers={['Payment method', '3D Secure 2.0 availability']}
        body={[
            ['2 Party (without AuthKey)', 'No'],
            ['2 Party (with AuthKey)', 'Yes'],
            ['3 Party - JavaScript Simple', 'Yes'],
            ['3 Party - JavaScript Advanced', 'Yes'],
            ['3 Party - Iframe Fields', 'Yes'],
        ]}
    />

    <h2>Card types supported</h2>
    <p>
        Visa and Mastercard are the only two card types that support 3D Secure.  If you attempt to process any other card type via Authentication API, it will
        be processed successfully without applying 3D Secure.
    </p>
    <Table
        headers={['Card type', '3D Secure 2.0 availability']}
        body={[            
            ['Visa', 'Yes'],
            ['Mastercard', 'Yes'],
            ['Amex', 'No'],
            ['Chine Union Pay (CUP)', 'No'],
            ['JCB', 'No'],
            ['Diners', 'No'],
        ]}
    />

 </Page>


}
export default ThreeDSecure;